import React, { useState } from "react";
import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

import InputDefault from "../../components/Form/InputDefault";
import NumberInput from "../../components/NumberInput";
import PaymentMethods from "../../components/PaymentMethods";
import Button from "../../components/Button";
import GradientButton from "../../components/GradientButton";
import AsyncStorage from "@react-native-async-storage/async-storage";

const DepositPaymentMethod = () => {
  const navigation = useNavigation();

  function onMethodSelected(method) {
    if (method === 'PIX') navigation.navigate('DepositPix');
    if (method === 'Boleto') navigation.navigate('DepositBoleto');
    if (method === 'CreditCard') navigation.navigate('DepositCreditCard');
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Depositar BRL"} />

      <View style={styles.container}>
        <PaymentMethods onMethodSelected={onMethodSelected} />
      </View>
    </View>
  );
};

export default DepositPaymentMethod;
